import {createSelector} from '@reduxjs/toolkit';
import {containsExtent, getArea} from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';
import {fromExtent} from 'ol/geom/Polygon';

import {rulesForMosaic} from '@explorer/util/mosaics.js';

const format = new GeoJSON();

export const getMosaicIds = state => state.mosaics.ids;

export const getSelectedMosaic = state => state.mosaics.selected;

export const getSelectedMosaicName = createSelector(
  [getSelectedMosaic],
  mosaic => mosaic?.name
);

export const getMosaics = state => state.mosaics.list;

const rules = state => state.basemapRules;
export const getRulesForMosaic = createSelector(
  [getSelectedMosaicName, rules],
  (name, rules) => rulesForMosaic(rules, name)
);

/**
 * This gives us the Multipolygon to highlight the AOIs the user has access to
 * If they do not cover the whole world
 */
export const getMosaicAOIs = createSelector(
  [getRulesForMosaic, getSelectedMosaic],
  (rules, mosaic) => {
    const aois = [];

    rules.forEach(rule => {
      let geo = rule.worldIntersect < 0.75 ? rule.aoiGeo : null;
      if (mosaic) {
        // The admin rule could have a bigger bbox than the mosaics actual AOI
        // If the mosaic bbox is smaller than the Admin rule, use it
        // This does not work for multipolygons as we want to highlight the individual shapes
        if (rule.aoi.length === 1) {
          const ratio = getArea(mosaic.bbox) / getArea(rule.extent);

          if (containsExtent(rule.extent, mosaic.bbox) && ratio < 0.75) {
            const mosaicExtent = fromExtent(mosaic.bbox);
            geo = JSON.parse(format.writeGeometry(mosaicExtent));
          }
        }
      }

      if (geo) {
        aois.push(geo);
      }
    });

    return aois;
  }
);
